import React from "react";
import { BarChart3, Bolt, HeartPulse, ShieldCheck, Wrench } from "lucide-react";

import { Hero, LogoCloud, FeaturesGrid, Testimonials, FAQ, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";
import { products } from "../content/products";
import { services } from "../content/services";

function Home() {
  return (
    <div>
      <Seo
        title="Business software & services"
        description="EasyBooks Solutions provides accounting, ERP, e-health systems, and software development services in Malawi. Simplify operations and scale with confidence."
      />
      <Hero
        title="Modern business software and services for teams that want to move faster."
        subtitle="From accounting and ERP to e-health platforms and custom software development, EasyBooks helps you simplify operations, improve visibility, and scale with confidence."
        primaryCta={{ label: "Talk to us", to: "/Contact" }}
        secondaryCta={{ label: "View products", to: "/EasyBooks_Accounting" }}
        imageSrc="Assets/eb-webapp.webp"
        imageAlt="EasyBooks Solutions"
        highlights={[
          "Built for SMEs and institutions",
          "Secure, customizable systems",
          "Local support with global standards",
          "Web, mobile, and automation expertise",
        ]}
      />

      <LogoCloud
        title="Trusted by organizations in Malawi and beyond"
        logos={[
          { src: "Assets/Clients/Clinton_Health_Access_Initiative.png", alt: "Clinton Health Access Initiative" },
          { src: "Assets/Clients/ALIDZIWA-WEB-LOGO.png", alt: "ALIDZIWA" },
          { src: "Assets/Clients/BMP.png", alt: "Blantyre Malaria Project" },
          { src: "Assets/Clients/Ministry of Health.png", alt: "Ministry of Health" },
          { src: "Assets/Clients/maranatha-logo.png", alt: "Maranatha" },
          { src: "Assets/Clients/MEGA-LOGO.png", alt: "Mega Signs" },
        ]}
      />

      <FeaturesGrid
        eyebrow="Products"
        title="Solutions designed to reduce admin, improve control, and deliver insights."
        subtitle="Choose a product suite that fits your needs today and evolves with you tomorrow."
        columns={3}
        features={products.map((p) => ({
          title: p.name,
          description: p.description,
          to: p.to,
          icon:
            p.id === "accounting"
              ? BarChart3
              : p.id === "erp"
                ? Wrench
                : HeartPulse,
        }))}
        cta={{ label: "Request a demo", to: "/Contact" }}
      />

      <FeaturesGrid
        eyebrow="Services"
        title="Expert delivery that keeps your teams shipping."
        subtitle="We help you build, modernize, and optimize end to end."
        columns={2}
        features={services.map((s) => ({
          title: s.name,
          description: s.description,
          to: s.to,
          icon: s.id === "software-dev" ? Bolt : ShieldCheck,
        }))}
      />

      <Testimonials
        eyebrow="Results"
        title="A partner you can rely on."
        subtitle="We focus on outcomes: usability, adoption, and measurable improvement."
        items={[
          {
            quote:
              "EasyBooks helped us simplify processes and improve visibility across day-to-day operations.",
            name: "Operations Lead",
            role: "",
          },
          {
            quote:
              "Reliable support, clear communication, and a solution that fit our needs without unnecessary complexity.",
            name: "Program Manager",
            role: "",
          },
          {
            quote:
              "From discovery to delivery, the team was proactive and focused on making the system easy for users.",
            name: "Finance Team",
            role: "",
          },
        ]}
      />

      <FAQ
        eyebrow="FAQ"
        title="Common questions"
        subtitle="If you don’t see your question here, contact us and we’ll help."
        items={[
          {
            q: "Can we deploy on-premise as well as in the cloud?",
            a: "Yes. Depending on your product and requirements, we support on-premise deployments and cloud hosting options.",
          },
          {
            q: "Do you customize your products to our workflows?",
            a: "Yes. We can tailor modules, add new features, and integrate with your existing processes where needed.",
          },
          {
            q: "Do you provide training and ongoing support?",
            a: "Yes. We support onboarding, user training, and ongoing maintenance so you stay productive and secure.",
          },
        ]}
      />

      <CTASection
        title="Ready to modernize your operations?"
        subtitle="Tell us what you’re trying to achieve and we’ll recommend the fastest path product, service, or both."
        primaryCta={{ label: "Contact sales", to: "/Contact" }}
        secondaryCta={{ label: "Explore products", to: "/EasyBooks_Accounting" }}
      />
    </div>
  );
}

export default Home;